const resizeHandler = [];
export function registerResizeHandler(element, handler) {
    resizeHandler.push([element, handler]);
    if (resizeHandler.length % 100 === 99) {
        const unhinged = [];
        for (const [element] of resizeHandler)
            if (!element.isConnected)
                unhinged.push(element);
        for (const element of unhinged)
            unregisterResizeHandler(element);
    }
}
export function unregisterResizeHandler(element) {
    while (resizeHandler.length) {
        const idx = resizeHandler.findIndex(([e, _]) => e === element);
        if (idx >= 0)
            resizeHandler.splice(idx, 1);
        else
            break;
    }
}
window.addEventListener('resize', () => {
    if (!resizeHandler.length)
        return;
    const unhinged = [];
    for (const [element, handler] of resizeHandler) {
        if (element.isConnected)
            handler();
        else
            unhinged.push(element);
    }
    for (const element of unhinged)
        unregisterResizeHandler(element);
});
